import React from 'react'
import Icon from '../../../ui/Icon/Icon'
import './PhoneLinks.sass'
import { useContext } from 'react'
import { AuthContext } from '../../../App'

function PhoneLinks() {
  // const { contacts } = useContext(AuthContext)
  return (
    <div className="PhoneLinks">
      <a href={`tel:+79022820919`} className="PhoneIcon">
        <Icon name="phone" weight="solid" />
      </a>
      <div className="Content">
        <a href={`tel:79022820919`} className="PhoneNumber ">
          +7 (902) 282-09-19
        </a>
        <span className="Description">Круглосуточно</span>
      </div>
      <a href={`https://t.me/+79022820919`} className="PhoneIcon">
        <Icon name="telegram" weight="brand" />
      </a>
      <a
        href={`https://api.whatsapp.com/send/?phone=79022820919`}
        className="PhoneIcon"
      >
        <Icon name="whatsapp" weight="brand" />
      </a>
    </div>
  )
}

export default PhoneLinks
